module.exports = require("next/document");